import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormikMultiSelectInput } from '../../../components/FormikMultiSelectInput/FormikMultiSelectInput';
import { FormikSelectInput } from '../../../components/FormikSelectInput/FormikSelectInput';
import { FormikTextInput } from '../../../components/FormikTextInput/FormikTextInput';

import styles from './CustomQuestions.module.scss';

export const CustomQuestions = ({ customQuestions }) => {
  const { t } = useTranslation('common');

  if (!customQuestions || customQuestions.length === 0) {
    return null;
  }

  const sortedQuestions = [...customQuestions].sort((a, b) => a.order - b.order);

  return (
    <div className={styles.customQuestionsContainer}>
      {sortedQuestions.map((question) => {
        const fieldName = `custom_question_${question.id}`;

        if (question.fieldType === 'text') {
          return (
            <FormikTextInput
              key={question.id}
              name={fieldName}
              label={question.title}
              placeholder={t('placeholders.writeYourAnswer')}
              isRequired={question.required}
            />
          );
        }

        if (question.fieldType === 'single_select_dropdown') {
          const options = question.options.map((option) => ({
            value: option,
            label: option,
          }));

          return (
            <FormikSelectInput
              key={question.id}
              name={fieldName}
              label={question.title}
              placeholder={t('placeholders.selectOption')}
              options={options}
              isRequired={question.required}
            />
          );
        }

        if (question.fieldType === 'multi_select_dropdown') {
          const options = question.options.map((option) => ({
            value: option,
            label: option,
          }));

          return (
            <FormikMultiSelectInput
              key={question.id}
              name={fieldName}
              label={question.title}
              placeholder={t('placeholders.selectOptions')}
              options={options}
              isRequired={question.required}
            />
          );
        }

        return null;
      })}
    </div>
  );
};
